// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__IfNNv","inner":"Footer_inner__2mVm2"};